<template>
  <div>
    <h1 slot="title" class="page-title">Add Third Party</h1>
    <div class="row">
      <div class="col-lg-12">
        <div class="card mb-3">
          <div class="card-body">
            <form-navigation-tabs
              :tabs="tabs"
              v-on:selected="setActive"
              :active="currentView"
            ></form-navigation-tabs>
            <transition name="component-fade" mode="in-out">
              <third-party-details
                :incident="incident"
                :mode="mode"
                v-if="currentView == 'third_party_details'"
                v-on:created="activateTabs"
                v-on:exists="activateTabs"
                v-on:unsaved-data="saveStatus"
                :third-party="third_party"
              ></third-party-details>

              <third-party-vehicle
                :incident="incident"
                :mode="mode"
                v-if="currentView == 'third_party_vehicle'"
                v-on:unsaved-data="saveStatus"
                :third-party="third_party"
              ></third-party-vehicle>

              <vehicle-location
                :incident="incident"
                :mode="mode"
                :third-party="third_party"
                v-if="currentView == 'vehicle_location'"
                v-on:unsaved-data="saveStatus"
              ></vehicle-location>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ThirdPartyDetails from './ThirdPartyDetails.vue';
import ThirdPartyVehicle from './ThirdPartyVehicle.vue';
import VehicleLocation from './VehicleLocation.vue';

export default {
  props: {
    incident: {
      type: String,
      required: true
    }
  },

  components: {
    'third-party-details': ThirdPartyDetails,
    'third-party-vehicle': ThirdPartyVehicle,
    'vehicle-location': VehicleLocation
  },

  data() {
    return {
      currentView: 'third_party_details',
      third_party: null,
      mode: 'add',
      tabs: [
        {
          name: 'third_party_details',
          label: 'TP Details',
          disabled: false
        },
        {
          name: 'third_party_vehicle',
          label: 'TP Vehicle',
          disabled: true
        },
        {
          name: 'vehicle_location',
          label: 'Vehicle Location',
          disabled: true
        }
      ]
    };
  },

  methods: {
    setActive(tab) {
      // check if unsaved data on the current form
      if (this.unsaved_data && this.currentView !== tab) {
        this.saveWarning(tab); // show alert if there is
      } else {
        this.currentView = tab;
      }
    },

    activateTabs(identifier) {
      this.third_party = identifier;

      this.tabs.forEach(tab => {
        tab.disabled = false;
      });
    },

    saveStatus(event) {
      this.unsaved_data = event;
    },

    saveWarning(tab) {
      window
        .swal({
          title: 'Are you sure?',
          text:
            'You will lose all details entered in this section if you continue!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Continue without saving',
          cancelButtonText: 'Cancel and stay in this section'
        })
        .then(
          () => {
            // Go to selected tab discarding changes
            this.currentView = tab;
            this.unsaved_data = false;
          },
          dismiss => {}
        );
    }
  }
};
</script>
